import { generateSessionStorage, generateStorage } from "@toss/storage";

export const sessionStorage = generateSessionStorage();
export const tossLocalStorage = generateStorage();

export const storageKeys = {
  ProductKey: "productKey",
  Account: "account",
  PayExemptCount: "payExemptCount",
  PaymentCycle: "payment_cycle",
  PaymentAmount: "payment_amount",
  PaymentProductKey: "payment_product_key",
  Email: "email",
  Name: "name",
  Ci: "ci",
  TemporaryToken: "temporaryToken",
  Phone: "phone",
  Gender: "gender",
  Address: "address",
  Agreement: "agreement",
  Birthdate: "birthdate",
  CouponCode: "couponCode",
  CouponIssuer: "couponIssuer",
  CouponTimeLeft: "couponTimeLeft",
  IsTossDC10: "is_toss_dc10",
  CouponTimeLeftTossDC10: "coupon_time_left_toss_dc10",
  IsToss: "is_toss",
  isConfirmContractVisit: "is_confirm_contract_visit",
  adisonClickKey: "adison_click_key",
  isNpay: "is_npay",
  PhoneVerificationCode: "phone_verification_code",
  benefitType: "benefit_type",
  productGroup: "productGroup",
  registeredRef: "registered_ref",
  VerificationRrnFront: "verificationRrnFront",
  VerificationRrnBack: "verificationRrnBack",
  VerificationCarrier: "verificationCarrier",
  SmsRequestNumber: "smsRequestNumber",
  ContractCheckReturnTo: "contract-check-return-to",
  isNewTouch: "is_new_touch",
  isPayCoupon: "is_pay_coupon",
  generalFunnels: "general_funnels",
  Platform: "platform",
  TemporaryCustomerId: "temporaryCustomerId",
  ContractCheckAuthPhone: "contract-check-auth-phone",
  /** 본인확인(PASS) 성공 후 돌아갈 경로. 없으면 /contract-check */
  VerificationReturnPath: "verification-return-path",
  PaymentMethodChangeInfo: "payment_method_change_info",
  FomoStartAt: "fomo_start_at",
  FomoReachedConfirmation: "fomo_reached_confirmation",
  FomoModalShown: "fomo_modal_shown",
  DirectVisitCount: "direct_visit_count",
  FomoVisitCounted: "fomo_visit_counted",
  IsRegistered: "is_registered",
  IsCrmReentry: "is_crm_reentry",
  ReferralUserKey: "referral_user_key",
  ReferralSignedUp: "referral_signed_up",
  ReferralVisitorId: "referral_visitor_id",
  QuizCouponActive: "quiz_coupon_active",
  AdsDiscountCampaign: "ads_discount_campaign",
  AdsDiscountCampaignIsToss: "ads_discount_campaign_is_toss",
  AdsDiscountCampaignIsTm: "ads_discount_campaign_is_tm",
  CrmDc10Active: "crm_dc10_active",
  FamilyPhotoDraft: "family_photo_draft",
  FamilyPhotoEntry: "family_photo_entry",
  FamilyPhotoSubmitted: "family_photo_submitted",
  PetFuneralEntry: "pet_funeral_entry",
  PetFuneralDraft: "pet_funeral_draft",
  kakaobank: "kakaobank",
  kuid: "kuid",
} as const;
